import styled from 'styled-components';
import { flexbox } from 'styled-system';
import { baseTheme } from '../../styles';
import { Box } from '../Box';
import { shouldForwardProp } from './utils';
/**
 * A flex which supports arbitrary margins and paddings and flex properties, where necessary.
 * 🚨Use scarcely!
 */

var Flex = styled(Box).withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Flex",
  componentId: "sc-1gsktcv-0"
})(["", ""], flexbox);
Flex.defaultProps = {
  theme: baseTheme,
  display: 'flex'
};
export default Flex;